import React from 'react';
import { SrcSet } from '@lib/image';

export interface RenderProps {
  imgProps: any;
  srcSet: SrcSet;
}

interface IPictureProps {
  srcSets: Record<string, SrcSet>;
  defaultWidth: number;
  className?: string;
  render: (opts: RenderProps) => React.ReactElement<{}>;
}

const SrcSetPicture = ({
  className = '',
  srcSets,
  defaultWidth,
  render,
}: IPictureProps) => {
  const defaultSrcSet = Object.values(srcSets)[0];
  return (
    <picture className={className}>
      {
          Object.entries(srcSets).map(([format, srcSet]) => (
            <React.Fragment key={format}>
              <source
                key={`${format}-media`}
                type={`image/${format}`}
                srcSet={srcSet.toSrcSet()}
                media={srcSet.breakpointSizes()}
              />
              <source
                key={`${format}-standalone`}
                type={`image/${format}`}
                srcSet={srcSet.urlForWidth(defaultWidth)}
              />
            </React.Fragment>
          ))
      }
      {render({
        imgProps: {
          src: defaultSrcSet.urlForWidth(defaultWidth),
          sizes: defaultSrcSet.breakpointSizes(),
          srcSet: defaultSrcSet.toSrcSet(),
        },
        srcSet: defaultSrcSet,
      })}
    </picture>
  );
};

export default SrcSetPicture;
